export const ADDON_ID = "storybook-design-token";
export const PANEL_ID = `${ADDON_ID}/panel`;
export const PARAM_KEY = `designToken`;

export const EVENTS = {
  RESULT: `${ADDON_ID}/result`,
  REQUEST: `${ADDON_ID}/request`,
  CLEAR: `${ADDON_ID}/clear`,
};
